import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  /** tell opened list components to refresh */
  @Output() profileListChanged = new EventEmitter(); // <boolean>();
}
